import { render, staticRenderFns } from "./mobile_integral_market.vue?vue&type=template&id=0900f55d&scoped=true&"
import script from "./mobile_integral_market.vue?vue&type=script&lang=js&"
export * from "./mobile_integral_market.vue?vue&type=script&lang=js&"
import style0 from "./mobile_integral_market.vue?vue&type=style&index=0&id=0900f55d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0900f55d",
  null
  
)

export default component.exports